(function () {
  const REVIEW_ID = 'shopify-block-AQ01WbGQ4MUNvSU1Ge__judge_me_reviews_review_widget_hXgaRM';
  const TARGET_SELECTOR = '.product__accordion.reviews .accordion__content.rte';

  function moveReviewWidget() {
    const reviewSection = document.getElementById(REVIEW_ID);
    const accordionContent = document.querySelector(TARGET_SELECTOR);

    // Prevent duplicate moves
    if (reviewSection && accordionContent && !accordionContent.contains(reviewSection)) {
      accordionContent.appendChild(reviewSection);
      return true;
    }

    return false;
  }

  // Try immediately (in case it's already loaded)
  if (moveReviewWidget()) return;

  // Observe DOM for async loading (Judge.me)
  const observer = new MutationObserver(() => {
    if (moveReviewWidget()) {
      observer.disconnect(); // stop once done
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Fallback: stop observer after 10s to avoid performance issues
  setTimeout(() => {
    observer.disconnect();
  }, 10000);
})();